<template>
    <v-list-tile>
        <v-dialog v-model="mostrarDialogExclusao" persistent max-width="500">
            <v-list-tile-title slot="activator">Excluir</v-list-tile-title>

            <v-card v-if="mostrarDialogExclusao && ehLicitacaoPublicada">
              <v-card-title class="primary modal-title" primary-title>
                Excluir Licitação
              </v-card-title>
              <v-card-text class="pb-0 az-form-content">
                <div class="az-text mb-3">
                  <p v-if="ehIntegracaoPrestacaoContasAtiva"><strong><label style="color: red !important;">Atenção:</label></strong> Ao excluir esta licitação, um evento
                    de cancelamento da <strong>Publicação</strong> e <strong>Pré-Publicação</strong> será automaticamente enviado ao E-Sfinge.</p>

                  <p><strong>Informe a justificativa para excluir a Licitação</strong></p>
                </div>

                <v-textarea v-model="justificativa"
                            :error-messages="errors.collect('Justificativa')"
                            v-validate="mostrarDialogExclusao? 'required' : ''"
                            :name="'Justificativa'"
                            label="Justificativa"
                            placeholder="Digite aqui a justificativa"
                            rows="3"
                            maxlength="1000"
                            :counter="1000"
                            class="required-field"/>
              </v-card-text>
              <v-card-actions class="acoes justify-center">
                <v-btn color="#777" flat @click="mostrarDialogExclusao = false">
                  Fechar
                </v-btn>
                <v-btn class="botao-primario confirmar" flat @click="excluirLicitacao">
                  Confirmar
                </v-btn>
              </v-card-actions>
            </v-card>

            <az-confirm v-if="mostrarDialogExclusao && !ehLicitacaoPublicada"
                        @onConfirm="excluirLicitacao"
                        @onDecline="mostrarDialogExclusao = false"
                        :maxWidth=320>
              <p v-if="ehIntegracaoPrestacaoContasAtiva"><strong><label style="color: red !important;">Atenção:</label>
                Ao excluir esta licitação, um evento de cancelamento da Pré-Publicação será automaticamente enviado ao
                E-Sfinge.</strong></p>
                <p>Tem certeza de que deseja continuar?</p>
            </az-confirm>
        </v-dialog>
    </v-list-tile>
</template>

<script>
    import {mapState} from 'vuex'
    import {actionTypes} from '@/commons/constants'

    export default {
        name: 'LicitacaoAtualizacaoAcoesExcluir',
        props:{
          licitacaoPublicada:{
            type: Boolean,
            default: null
          }
        },
      data() {
            return {
                mostrarDialogExclusao: false,
                justificativa: null
            }
        },
      methods: {
            async buscarProtocolo() {
              if (this.ehIntegracaoPrestacaoContasAtiva) {
                let payload = {
                  licitacaoId: this.licitacao.id,
                  operacao: "prepublicacao"
                };

                const response = await this.buscarProtocoloEsfinge(payload);
                this.protocolo = response !== "" ? response : undefined;
              }
            },
            async excluirLicitacao() {
                await this.$store.dispatch(actionTypes.REMOVER_LICITACAO, {
                  licitacaoId:this.licitacao.id, justificativa:this.justificativa
                })
                this.$router.push({name: 'licitacaoBusca'})
                this.mostrarNotificacaoSucessoDefault()
            },
        },
      computed: {
        ...mapState(['licitacao', 'parametros']),

        ehLicitacaoPublicada(){
          return this.licitacaoPublicada
        },
        ehIntegracaoPrestacaoContasAtiva(){
          return this.parametros.propriedadesLicitacao.integration.integracaoSistemaDePrestacaoContasAtiva
        }
      }

    }
</script>